<template>
  <div class="w-full h-full px-6 pt-6 pb-8 box-border flex flex-col overflow-auto">
    <header class="w-full mb-3 flex items-center justify-between">
      <div class="flex-1">
        <span class="text-medium text-theme-black-650">样本群组：</span>
        <el-select
          v-model="condition.groupId"
          size="small"
          class="field-text-size field-text-spacing"
          style="width: 325px"
          placeholder="样本群组"
          @change="
            setRowSelection()
            searchList()
          "
        >
          <el-option v-for="item of groups" :key="item.id" :label="item.groupName" :value="item.id" />
        </el-select>
        <span class="ml-3 text-theme text-medium cursor-pointer select-none" @click="scVisible = true">筛选条件</span>
      </div>
      <div class="flex items-center">
        <!-- <el-button size="small" type="primary" class="text-medium">创建新群组</el-button> -->
        <el-button size="small" class="ml-3 text-medium" @click="toSampleGroup"
          >群组管理</el-button
        >
      </div>
    </header>
    <div class="flex-1 overflow-hidden">
      <data-table
        ref="tableRef"
        class="w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        height="calc(100% - 48px)"
        align="left"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="list.length > 0"
        :page="page"
        :disabled-all-check="checkAll"
        selection
        @selection-change="changeSelected"
        @size-change="changeSize"
        @pagination-current-change="changeNum"
      >
        <template #local="{ row }">
          <div v-truncate="joinStr(row.local)"></div>
        </template>
        <template #page-left>
          <div class="flex items-center">
            <p class="mr-6 text-medium text-theme-black-650">
              <el-checkbox :disabled="list.length === 0 || checkAll" v-model="checkPageAll">
                已选择 <span class="text-theme">{{ checkAll ? page.total : selectList.length }}</span> 项
              </el-checkbox>
            </p>
            <el-checkbox v-model="checkAll" :disabled="page.total === 0">选择全部</el-checkbox>
            <el-button :disabled="disabledAdd" :loading="addLoading" type="primary" size="small" class="ml-3" @click="addHandle"
              >添为收信人</el-button
            >
          </div>
        </template>
      </data-table>
    </div>
    <footer class="mt-5 mb-8 px-4 py-3 box-border bg-card-bg-gray">
      <header class="leading-6 text-medium text-theme-black-850">说明：</header>
      <ul class="flex flex-col text-medium text-theme-black-850">
        <li class="leading-6">1. 无手机号的样本将在保存时被自动剔除</li>
        <li class="leading-6">2. 相同手机号重复添加时，仅保留一个收件人</li>
      </ul>
    </footer>
    <search-condition ref="searchCondition" :visible.sync="scVisible" @search="searchCondition" />
  </div>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import SearchCondition from '@/components/base/SearchCondition'
import GlobalConfig from '@/global/config'
import { getSampleGroup, getSamplePageList, saveSmsSamples, removeSmsSamples } from '@/api/wenjuan/sample_new'
import { pageMixins } from '@/mixins/publish'
import { groupColumns } from '../config/sms-sending'
import { toWJB } from '@/assets/js/base-platform'

export default {
  name: 'AddRecipientGroup',
  mixins: [pageMixins],
  components: {
    DataTable,
    SearchCondition
  },
  data() {
    return {
      groups: [],
      selectList: [],
      condition: {
        groupId: ''
      },
      filterCond: {},
      list: [],
      tableLoading: false,
      columns: groupColumns,
      checkAllSource: false,
      scVisible: false,
      addLoading: false
    }
  },
  computed: {
    disabledAdd() {
      if (this.list.length === 0) return true
      return !this.checkAll && this.selectList.length === 0
    },
    checkPageAll: {
      get() {
        if (this.list.length === 0) return false
        const sIds = this.selectList.map(m => m.id)
        return this.list.every(e => sIds.includes(e.id))
      },
      set() {
        const table = this.$refs.tableRef
        if (table) {
          table.toggleAllSelection()
        }
      }
    },
    checkAll: {
      get() {
        if (this.page.total === 0) return false
        return this.selectList.length === this.page.total ? true : this.checkAllSource
      },
      set(bool) {
        if (!bool) {
          this.selectList.splice(0)
          this.$refs.tableRef.clearSelection()
        }
        this.checkAllSource = bool
      }
    }
  },
  mounted() {
    this.getSampleGroups()
  },
  methods: {
    joinStr(arr) {
      if (Array.isArray(arr)) {
        return arr.join('')
      }
      return arr
    },
    getSampleGroups() {
      this.tableLoading = true
      getSampleGroup()
        .then(groups => {
          this.groups = groups || []
          this.condition.groupId = this.groups[0]?.id || ''
          this.searchList()
        })
        .catch(() => {
          this.$message.error('获取样本群组失败')
          this.tableLoading = false
        })
    },
    getList() {
      const { groupId } = this.condition
      const { currentPage, pageSize } = this.page
      const data = {
        groupId,
        ...this.filterCond
      }
      const params = {
        current: currentPage,
        size: pageSize,
        descs: 'create_time'
      }
      this.tableLoading = true
      getSamplePageList(data, params)
        .then(res => {
          const { records, total, current, size } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total || 0
          this.page.currentPage = current
          this.page.pageSize = size
        })
        .catch(e => {
          this.$message.error(e?.msg || '获取样本数据失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    changeSelected(rows) {
      const rowMap = {}
      for (const row of rows) {
        const keys = Object.keys(rowMap)
        if (keys.includes(`${row.phone}`)) {
          this.$refs.tableRef.toggleRowSelection(rowMap[row.phone], false)
        }
        rowMap[row.phone] = row
      }
      this.selectList = Object.values(rowMap)
    },
    // 暂时无法回填复选框
    // setRowSelection(rows) {
    //   if (this.$refs.tableRef) {
    //     this.$refs.tableRef.clearSelection();
    //     for (const item of rows) {
    //       this.$refs.tableRef.toggleRowSelection(item, true);
    //     }
    //     this.list = JSON.parse(JSON.stringify(this.list));
    //   }
    // },
    setRowSelection() {
      if (this.checkAll) {
        this.checkAll = false
      }
      this.$refs.tableRef.clearSelection()
    },
    toSampleGroup() {
      this.$router.push({
        name: 'sample-company'
      })
    },
    searchCondition(params) {
      this.filterCond = params
      this.searchList()
    },
    async addHandle() {
      if (!this.disabledAdd) {
        const delReq = {
          surveyId: GlobalConfig.getSurveyId(),
          groupIds: this.groups.map(m => m.id),
          sampleIds: []
        }
        const saveReq = {
          surveyId: GlobalConfig.getSurveyId()
        }
        if (this.checkAll) {
          Object.assign(saveReq, delReq, { groupIds: [this.condition.groupId] })
        } else {
          saveReq.groupIds = []
          saveReq.sampleIds = this.selectList.map(m => m.id)
        }
        this.addLoading = true
        try {
          await removeSmsSamples(delReq)
          await saveSmsSamples(saveReq)
          const data = this.checkAll
            ? {
                type: 'checkAll',
                list: this.groups
              }
            : {
                type: 'check',
                list: this.selectList
              }
          this.$emit('confirm-add', data)
        } catch (e) {
          console.error('save sample error:', e)
          this.$message.error('保存样本选择失败')
        } finally {
          this.addLoading = false
        }
      } else {
        this.$message.warning('请先选择数据后添加')
      }
    }
  }
}
</script>
